<template>
  <b-row>
    <b-col>
      <b-card class="p-1 p-md-3">

        <b-card-title>
          {{ $t('withdraw-text') }}
        </b-card-title>
        <b-row>
          <b-col
            sm="12"
          >
            <dashboard-alert
              variant="success"
              :title="$t('withdraw-alert-text')"
            />

          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <DepositButton
              variant="success"
              :to="`/${$i18n.locale}/customer-wallets/fiat/withdraw`"
              :title-key="$t('fiat_withdraw')"
            />
          </b-col>
          <b-col>
            <DepositButton
              variant="info"
              :to="`/${$i18n.locale}/crypto-wallets`"
              :title-key="$t('crypto-withdraw')"
            />
          </b-col>
        </b-row>
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
import DashboardAlert from '@/views/theme2/dashboard/dashboardAlert.vue'
import DepositButton from '../../components/DepositButton.vue'

export default {
  components: {
    DashboardAlert,
    DepositButton,
  },
}
</script>
    <style>
    .btn-style{
      margin: 5px;
       width:100% ;
       height: 100px;
    }
    </style>
